import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';  // Import swiper CSS for proper styling
import 'swiper/css/navigation';  // Optional: if you want default swiper navigation styling
import 'swiper/css/pagination';  // Optional: for pagination styling
import { sideSliderStyles as styles } from './sideSlider.tailwind'; // Custom styles
import side_slider_arrow from '../../assets/svgs/side_slider_arrow.svg';
import { sliderImages } from './slider.data';

// Authenticationn Layout Slider
export const SideSlider = () => {
  const swiperRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Function to handle next slide
  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext(); // Use the swiper instance to go to the next slide
    }
  };

  // Function to handle previouse slide
  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev(); // Use the swiper instance to go to the previous slide
    }
  };

  // customizing swiper
  const options = {
    navigation: false, // Disable default navigation dots
    slidesPerView: 1, // Adjust according to your needs
    onSlideChange: (swiper) => setCurrentSlide(swiper.realIndex), // Use realIndex instead
    modules: [Navigation] // *IMPORTANT* Add required modules, unless it will not work
  }

  return (
    <div className={styles.slidercontainer}>
      <div className={styles.slidercontent}>
        {/* Side Slider */}
        <Swiper ref={swiperRef} {...options} className='w-full h-full'>
          {sliderImages.map((image, key) => (
            <SwiperSlide key={key}>
              <img src={image.url} alt={`Slide ${key + 1}`} className={styles.sliderimage} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Positioned arrows */}
      <div className={styles.arrowscontainer}>
        {/* Forward Button */}
        <button className={styles.arrow} onClick={handlePrev} disabled={currentSlide === 0}>
          <img src={side_slider_arrow} alt="Arrow" className={`${styles.arrowImage} rotate-180`} />
        </button>
        {/* Backward Button */}
        <button className={styles.arrow} onClick={handleNext} disabled={currentSlide === sliderImages.length - 1}>
          <img src={side_slider_arrow} alt="Arrow" className={styles.arrowImage}  />
        </button>
      </div>
    </div>
  );
};
